import Markdown from 'markdown-to-jsx';
import styled, { css } from 'styled-components';

export const MarkdownStyled = styled(Markdown)`
  ${({ theme: { fontWeight, font, color, spacing } }) => css`
    hr {
      margin: ${spacing.lg} ${spacing.md};
      height: 1px;
      border: none;
      background-color: ${color.lightGrey};
    }
    strong {
      font-weight: ${fontWeight.bold};
    }
    em {
      font-style: italic;
    }
    h1 {
      ${font.h1}
      margin: ${spacing.md} 0;
    }
    h2 {
      ${font.h2}
      margin: ${spacing.md} 0;
    }
    h3,
    h4,
    h5,
    h6 {
      margin: ${spacing.md} 0;
    }
    p {
      ${font.body}
      margin: ${spacing.md} 0;
    }
    blockquote {
      border-left: 4px solid ${color.turquoise};
      padding: ${spacing.sm} ${spacing.md};
      background-color: ${color.turquoise20};
    }
    a {
      color: ${(props) => props.theme.color.turquoise};
      :hover {
        text-decoration: underline;
      }
    }
  `}
`;
